import * as React from 'react';
import { withRouter } from 'react-router';
import injectSheet from 'react-jss';
import { Row, Col, Tooltip, Divider } from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getBidTotal, getUnitByMode } from '../pages/Enquiry/InquiryUtils';
import FreightPerUnit from './FreightPerUnit';
import { InquiryModes } from 'src/Library/Constants';
const styles = (theme: any) => ({
  tooltip: {
    fontSize: 11,
    width: 180,
  },
  totalTooltip: {
    fontSize: 11,
  },
});

interface PricePerContainerProps {
  containerTypesKeyVal: any;
  containerTypes: any;
  containerDetails: any;
  commentTextStyle: any;
  amount: any;
  currency: any;
  mode: any;
  sourceObjectType: any;
  currencySymbols: any;
  totalPrice: any;
  freightPerUnit: any;
  perLabel: any;
  classes: any;
  userCurrency: string;
  exchangeRates: {[key: string]: number};
}

class PricePerContainer extends React.PureComponent<PricePerContainerProps, any> {
  constructor(props) {
    super(props);
  }

  getContainerType(key) {
    const { containerTypesKeyVal } = this.props;
    if (!key || !containerTypesKeyVal) return;
    const type = containerTypesKeyVal.filter(item => item.key === key);
    if (type.length > 0) return type[0].label;
  }

  isTotalPriceVisibile = () => {
    const { containerDetails, sourceObjectType } = this.props;
    return containerDetails &&
      (containerDetails.length > 1 || containerDetails[0].count > 1) || sourceObjectType === 'BID';
  }

  renderTitle = () => {
    const { containerTypes, classes, currencySymbols, currency, totalPrice,
      freightPerUnit, mode, exchangeRates, userCurrency } = this.props;
      
    if (!totalPrice && [InquiryModes.TRAILER, InquiryModes.DOMESTIC].includes(mode)) {
      return '';
    }
    const convertedPrice = totalPrice?.amount;
    return (<>
          {totalPrice ? (this.isTotalPriceVisibile() ? <Row>
          <div className={ classes.totalTooltip }>
            Total Price
              <span style={{ paddingLeft: '6px' }}>
              {`${getBidTotal(parseFloat(`${convertedPrice}`))}`}
              &nbsp;{currency}
              </span>
          </div>
          </Row> : '') :
          // <Row><div className={classes.tooltip}>
          //   {containerTypes && containerTypes.length ?
          //   <>
          //     <Col span={6}>Type</Col><Col span={12}></Col><Col span={6}>Price</Col>
          //   </> : null}
          //   {containerTypes && containerTypes.map(item =>
          //   <>
          //     <Col span={17}>
          //       {`${item.containerSize} ${this.getContainerType(item.containerType)}`}
          //     </Col>
          //     <Col span={1}></Col>
          //     <Col span={6}> {currencySymbol}
          //     {`${getBidTotal(parseFloat((item.total.amount)))}`}</Col>
          //   </>)}</div></Row>
            ''}
        {freightPerUnit && ![InquiryModes.TRAILER, InquiryModes.DOMESTIC].includes(mode) && <FreightPerUnit
          amount={freightPerUnit && (freightPerUnit.amount) }
          currency={freightPerUnit && freightPerUnit.currency}
          perLabel={freightPerUnit && freightPerUnit.format }
          fontColor="white"
          />}</>
    );
  }

  render () {
    const {
      amount,
      perLabel,
      currencySymbols,
      currency,
      commentTextStyle,
      mode,
      sourceObjectType,
      totalPrice,
      userCurrency,
      exchangeRates
    } = this.props;
    const unit = perLabel || getUnitByMode(mode);
    const currencySymbol = `${InquiryModes.DOMESTIC === mode ? totalPrice?.currency : currency}`;
    const amountInt = getBidTotal(parseFloat(InquiryModes.DOMESTIC === mode ? totalPrice?.amount : amount));
    return (
      <span>
        {commentTextStyle ?
        <span style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
          <span style={{ fontSize: 10 }}>
            <span style={{ marginRight: '5px' }}>Price per {unit}</span>
            <span style={{
              fontSize: 12,
            }}>{amountInt}&nbsp;{currencySymbol}</span>
          </span>
        </span>
        :
        <Tooltip title={this.renderTitle()}>
          <span style={{ fontSize: 12}}>
            <strong style={{ fontSize: 12 }}>
              <span style={{ fontSize: 14}}>{amountInt}</span>
              <span>&nbsp;{currencySymbol}</span>
            </strong>
          </span>
          {InquiryModes.DOMESTIC !== mode ? <span style={{ fontSize: 8 }}>/ {unit}</span> : ''}
        </Tooltip>}
      </span>
    );
  }
}

const mapStateToProps = ({ masterData, staticData }) => ({
  currencySymbols: masterData.currencySymbols,
  containerTypesKeyVal: staticData.containerTypesKeyVal,
  userCurrency: masterData?.userData?.user_metadata?.user_currency,
});

const PricePerContainerStyled = injectSheet(styles)(PricePerContainer);
export default withRouter(connect(mapStateToProps, null)(PricePerContainerStyled));
